/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayMatchMvpDtoSchema = z.object({
  userId: z.string().nullish(),
  name: z.string().nullish(),
  position: z.string().nullish(),
  categoriesWon: z.optional(z.int()),
  categories: z.array(z.string()).nullish(),
});
